import { COUPON_COLORS } from '@/styles/coupon';
import { SxProps, Theme } from '@mui/material';

export const containerCouponStripSX: SxProps<Theme> = {
	display: 'flex',
	flexWrap: {
		xs: 'wrap',
		sm: 'nowrap',
	},
	alignItems: 'center',
	gap: '14px',
	padding: '12px 16px',
	border: `1px solid ${COUPON_COLORS.border}`,
	borderRadius: '4px',
	backgroundColor: COUPON_COLORS.surface,
	color: COUPON_COLORS.text,
	width: '100%',
};

export const badgeCouponStripSX: SxProps<Theme> = {
	flex: 'none',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '52px',
	height: '52px',
	borderRadius: '50%',
	backgroundColor: 'primary.main',
	color: 'primary.contrastText',
	fontWeight: 700,
	fontSize: 'var(--font-size-sm)',
};

export const textCouponStripSX: SxProps<Theme> = {
	flex: 1,
	minWidth: 0,
};

export const titleCouponStripSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-md)',
	fontWeight: 700,
	lineHeight: '24px',
	color: COUPON_COLORS.text,
};

export const descriptionCouponStripSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	lineHeight: '20px',
	color: COUPON_COLORS.textSecondary,
};

export const buttonCouponStripSX: SxProps<Theme> = {
	flex: 'none',
	width: {
		xs: '100%',
		sm: 'auto',
	},
	padding: '10px 20px',
	fontSize: 'var(--font-size-default)',
	whiteSpace: 'nowrap',
};
